const maxHistory = 10 // Adjust if needed
const history = []

/*
  Example:
  {
    pathname: '/items/123',
    search: '?filter=new',
    hash: '',
    state: null,
    key: 'xyz'
  }
*/

export const routeTracker = {
	getCurrent: () => history[history.length - 1] || null,
	getPrevious: () => history[history.length - 2] || null,
	getBeforePrevious: () => history[history.length - 3] || null,

	getHistory: () => [...history], // returns a copy of the entire history

	set: (newLocation) => {
		const last = history[history.length - 1]
		const isSamePage =
			last &&
			last.pathname === newLocation.pathname &&
			last.search === newLocation.search &&
			last.hash === newLocation.hash

		if (isSamePage) {
			history[history.length - 1] = { ...newLocation }
			return
		}

		history.push({ ...newLocation })

		// Keep history size within maxHistory
		if (history.length > maxHistory) {
			history.shift() // remove oldest entry
		}
	},

	update: (indexFromEnd, updaterFn) => {
		// indexFromEnd: 0 = current, 1 = previous, 2 = beforePrevious, etc.
		const index = history.length - 1 - indexFromEnd

		if (index < 0 || index >= history.length) return

		const current = history[index] || {}
		const updated = updaterFn(current)
		history[index] = { ...current, ...updated }
	},

	reset: () => {
		history.length = 0
	},
}
